import Vue from 'vue'
import _ from 'lodash'
import $ from 'jQuery'
import store from '@/store'
import $glAuth from '@/services/$glAuth'
import $glEventHub from '@/services/$glEventHub'

/*
  how to use:
    v-gl-wl="{ insert: 'loginLogo' }"
    v-gl-wl="{ apply: 'linkColor' }"
    v-gl-wl="{ apply: [ 'brandBtnBgColor', 'brandBtnTextColor' ], fresh: true }"
*/
Vue.directive('gl-wl', {

  // props
  props: {
    options: Object
  },

  // on bind
  bind (el, binding, vnode) {
    // init $bound / toggle off on unbind
    el.$bound = true

    // define: options
    let options = binding.value

    // fn: applies wl options to an element
    let _setElement = () => {
      // if has config
      if (_.isObject(store.getters.config) && _.isObject(store.getters.config.agency)) {
        // only set $bound elements
        if (el.$bound) {
          // loginLogo
          if (options.insert === 'loginLogo') {
            el.src = store.getters.config.agency.loginLogo
          }

          // headerLogo
          if (options.insert === 'headerLogo') {
            el.src = store.getters.config.agency.headerLogo
          }

          if (options.removeIf === 'hideExport') {
            if (store.getters.config.agency.hideExport === 'true') {
              // Removing the ExportCSV button.  Need to wrap it in a timeout to prevent this from waiting.
              // Something about event loops and call stacks....
              setTimeout(() => el.remove(), 0)
            }
          }

          // if: options.apply
          if (options.apply) {
            // brandBtnBgColor
            if (_.includes(options.apply, 'brandBtnBgColor') || options.apply.brandBtnBgColor) {
              el.style.backgroundColor = store.getters.config.agency.brandBtnBgColor
            }

            // brandBtnTextColor
            if (_.includes(options.apply, 'brandBtnTextColor') || options.apply.brandBtnTextColor) {
              el.style.color = store.getters.config.agency.brandBtnTextColor
            }

            // brandFontWeight
            if (_.includes(options.apply, 'brandFontWeight') || options.apply.brandFontWeight) {
              el.style.fontWeight = store.getters.config.agency.brandFontWeight
            }

            // linkColor
            if (_.includes(options.apply, 'linkColor') || options.apply.linkColor) {
              el.style.color = store.getters.config.agency.linkColor
            }

            // fontFamily
            if (_.includes(options.apply, 'fontFamily') || options.apply.fontFamily) {
              el.style.fontFamily = store.getters.config.agency.fontFamily
            }

            // bgColor
            if (_.includes(options.apply, 'bgColor') || options.apply.bgColor) {
              el.style.backgroundColor = store.getters.config.agency.bgColor
            }

            // headerBgColor
            if (_.includes(options.apply, 'headerBgColor') || options.apply.headerBgColor) {
              el.style.backgroundColor = store.getters.config.agency.headerBgColor
            }

            // headerFontWeight
            if (_.includes(options.apply, 'headerFontWeight') || options.apply.headerFontWeight) {
              el.style.fontWeight = store.getters.config.agency.headerFontWeight
            }

            // headerTextColor
            if (_.includes(options.apply, 'headerTextColor') || options.apply.headerTextColor) {
              el.style.color = store.getters.config.agency.headerTextColor
            }

            // headerBorderColor
            if (_.includes(options.apply, 'headerBorderColor') || options.apply.headerBorderColor) {
              el.style.borderColor = store.getters.config.agency.headerBorderColor
            }

            // formLabelColor
            if (_.includes(options.apply, 'formLabelColor') || options.apply.formLabelColor) {
              Vue.nextTick(() => {
                $(el).find('.col-form-label').css('color', store.getters.config.agency.formLabelColor)
              })
            }

            // formLabelFontWeight
            if (_.includes(options.apply, 'formLabelFontWeight') || options.apply.formLabelFontWeight) {
              Vue.nextTick(() => {
                $(el).find('.col-form-label').css('fontWeight', store.getters.config.agency.formLabelFontWeight)
              })
            }
          }
        } else {
          // on el dead -> destroy event
          $glEventHub.$off('store.config.commit', _setElement)
        }
      }
    }

    // if config -> set element
    if (_.isObject(store.getters.config)) {
      _setElement()
    }

    // if no config OR fresh is requested -> get config then set element
    if (!store.getters.config || options.fresh) {
      $glAuth.getConfig()
        .catch(e => console.log(e))
        .then(() => _setElement())
    }

    // on config commit -> set element
    $glEventHub.$on('store.config.commit', _setElement)
  },

  // on destroy
  unbind (el) {
    // tip $bound flag
    el.$bound = false
  }
})



// WEBPACK FOOTER //
// ./src/directives/gl-wl.js